import React, {useEffect ,useState } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const Faq = () => {
    useEffect(() => {
        document.title = 'Faq -  The Air Force School Subroto Park';  
    }, []);  
    const [show,setShow] = useState(0);
    const handleClick = (index) => {
        setShow(show === index ? 0 : index);
    }
    const data = [
        {
            id: 1 ,
        title: "Where is the school located?" ,
        desc: <p> The school is located in Subroto Park on a 15 acre campus. It is 1 ½ KM from Dhaula Kuan (NH-8) on the Delhi Airport road.
              <br/>
              <a href="https://maps.app.goo.gl/cinfiVjHyeLi5Avs5" target="_blank" rel="noopener noreferrer">View on Google Maps</a>
            </p>
        
        },
        {
            id: 2,
        title: "Who runs The Air Force School?",
        desc: <p> The Air Force School (TAFS) is run by IAF Educational & Cultural Society as an unaided school. </p>
        
        },
        {
            id: 3,
        title: "Whether the school is affiliated with CBSE or ICSE?",
        desc: <p> The school is permanently affiliated with Central Board of Secondary Education (CBSE) and recognized by Directorate of Education, Govt of NCT Delhi. </p>
        
        },
        {
            id: 4,
        title: "Whether the admission is available for the civilians?",
        
        desc: <p> Yes.  The admission for civilians/Non Air Force (NAF) category is open in Class UKG & Class XI </p>
        
        },
        {
            id: 5,
        title: "Whom to contact for Admission?",
        desc: <p> The admission is being controlled/centrally by the Chairman Managing Committee (CMC), Air Force Schools, C/o CSDO Complex, Subroto Park, New Delhi-110010 contact by E-Mail: cmcafschools@gmail.com or Telephone: 011-25695178 or 25687194 Ext. 6090 (0930 hrs to 1700 hrs from Monday to Friday). </p>
        
        },
        {
            id: 6,
        title: "What is the eligibility criteria for Nursery/UKG and when will be the forms available?",
        desc: <p> The child should complete 4 years as on 31st March for ensuing academic session. The registration forms shall normally be made available in last week of December by the CMC’s Office & there is no Nursery and entry level is UKG. The advertisement for admission to Class UKG will be published in The Hindustan Times in the month of December and be published in the school website www.tafssp.com. </p>
        
        },
        {
            id: 7,
        title: "What is the procedure for admission to other Classes i.e. from Classes 1 to 11 for NAF category?",
        desc: <p> The admission for Classes I to IX and XII shall be considered in the month of March/April subject to availability of vacancies. Procedure shall be notified on the school website. </p>
        
        },
        {
            id: 8,
        title: "What is the admission procedure for Class 11?",
        desc: <p> After declaration of Class 10 result by CBSE for Delhi region, the interested parents/candidates are to contact the CMC’s office along with the copy of mark list. The admission procedure for admission to Class XI is under review keeping in mind the new evaluation system introduced by CBSE. </p>
        },
        {
            id: 9,
            title: "What are all the streams available in Class XI?", 
           desc : <p>Science – Medical Stream (with Maths): English, Maths, Physics, Chemistry, Biology <br/> 
           Science – Medical Stream (without Maths): English, Physics, Chemistry, Biology, Informatics Practices or Home Science or Psychology or Physical Education <br/> 
           Science – Non Medical Stream: English, Maths, Physics, Chemistry, Computer Science or Economics/Physical Education (20 seats) <br/> 
           Commerce with Maths: English, Maths, Business Studies, Economics, Accountancy <br/> 
           Commerce without Maths: English, Home Science or Informatics Practices, Business Studies, Accountancy, Economics  <br/> 
           Humanities with Maths: English, History, Economics or Political Science, Geography, Maths <br/> 
           Humanities without Maths: English, History, Economics or Political Science, Geography, Home Science or Informatics Practices or Psychology. </p>
        },
        { id: 10, title: "Whether the school is teaching French or any other foreign language in the school?", desc : <p> No. English & Hindi are the languages available from Classes UKG to V. In addition to English & Hindi Sanskrit is being taught from Classes VI to VIII. In Classes IX & X the child has to study English and Hindi as language. </p> 
            },
            { id: 11, title: "Which syllabus is being followed by the school?", desc : <p> The school is following the syllabus as prescribed by CBSE. The textbooks from Classes UKG to V are from private publications & Classes VI to XII mainly use NCERT/CBSE books. </p> 
            },
            { id:12, title: "Whether the school is conducting any special coaching for Engineering or Medical?", desc : <p> There is no special coaching for Engineering or Medical. However, the teachers help the students in preparing for various entrance examinations. </p> 
            },
            { id: 13, title: "Do the students take the NTSE and JSTS examination?", desc : <p> Yes. The school encourages students of class VIII and IX to take the NTSE and JSTS examinations respectively. </p> 
            },
            { id:14, title: "Can I have the list of extra-curricular activities taking place in the school?", desc :  <p>The school is conducting various extra-curricular activities i.e. Painting, Sculpture, Journalism, Instrumental and Vocal Music, Indian Dance, Electronics, NCC and preparation of bakery/pickle items in the Home Science Section, Interact Club, Debating Club. School has various Clubs viz EVS, Rasayan, Astronomy, Consumer club, etc. The school celebrates the Annual Day, Annual Sports Day, Independence Day, Children’s Day and Teacher’s Day. Departmental Exhibitions are being held on the Open House Day. In the Junior Wing, students are exposed to our cultural heritage by celebrating various religious & national festivals. The school also organises various Inter & Intra House/Class Competitions on Quiz, Debate, Painting, Essay Writing & sports events as well. The school participates in various inter school / zonal and National events in Academic, Sports & Co-curricular Activities. </p> 
            },
            { id: 15, title: "Does the school have a sports field? What are all the sports activities being conducted in the school?", desc : <p> The school does have its own sports field and is also using the sports ground of Western Air Command, Air Force. The school is providing facilities for cricket, badminton, basketball, foot ball, table tennis, lawn tennis, volley ball and athletic events.  </p> 
            },
            { id:16, title: "How can I contact Class Teacher/Subject Teachers, Vice Principal or Principal to know about the performance of my ward?", desc : <p> The parent can contact the teachers, Vice Principal & Principal through the Management Information System or take an appointment by sending a note through your ward in the student diary. The parent can also communicate with the school through e-mail ( tafsdelhi@gmail.com) </p> }
             ,{ id:17, title: "What is the fee structure for civilian category and periodicity of payment the school fee?", desc : <p> The school fee is charged on quarterly basis. The payment is to be made by cash at the time of admission. The fee slips are issued in the months of Apr, Jul, Oct, Jan and the fee is to be paid by 10th of the month. The following fee is charged on quarterly basis :- <br/>
             Tuition Fees. <br/>
             Computer Fees (from Classes UKG to VIII & optional for classes IX to XII). <br/>
             Management Information System (MIS) Charges. <br/>
             Bus Fee (for bus users only) The following fee shall be charged once in a year i.e. in the month of April. Annual Fee. <br/>
             Development Fee. <br/>
             School Diary. <br/>
             Students Identity Card. <br/>
             PTA Fund. <br/>
             Examination Sheet & Worksheet for UKG to V In case of withdrawals the Annual Fee & Development fee is not refunded. </p> },
              
{ id:18,
    title: "Is there any concession on fee available for Ex-serviceman? ",
  desc : <p> No. There is no fee concession available for ex-serviceman. They have to pay the fee at par with NAF/civilian category.  </p>
  
  },
  { id:19,
    title: "If there is any fee concession available for girl child? ",
  desc : <p> There is no fee concession for girl child. </p>
  
  },
  { id:20,
    title: "Whether the school is having hostel for boys & girls? ",
  desc : <p> The school is having hostel facility only for Boys from Class 6 onwards. This facility is available only for children outside the NCR. </p>
  
  },
  { id:21,
    title: "Where can we buy the school books/stationery & uniform? ",
  desc : <p> The books & uniform shop is available in the school welfare centre on working days i.e. Monday to Friday from 0900 hrs to 1200 hrs. Parents can buy books & uniform from any other shop also. </p>
  
  },
  { id:22,
    title: "Whether the school is having medical facility? ",
  desc : <p> Yes. The school is having sick-bay and the doctor is available. In case of emergency the school takes help from Station Medicare Centre (SMC), AF CME. </p>
  
  },
  { id:23,
    title: "Whether the school transport available? ",
  desc : <p> Yes. The school is operating bus services on limited routes. The details of bus routes are available on the school website under the page of transport. For Air Force service personnel the buses are being operated from MT Section of concerned AF Units. </p>
  }

        ] 

  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                  <li>About Us</li>
                 <li>Faq</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Faq </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                    {data.map((item) => (
                        <div key={item.id} className="faq">
                          <h3 onClick={() => handleClick(item.id)}>{item.title}</h3>
                          <div className={show === item.id ? "open" : ""}>
                            {show === item.id && item.desc}
                          </div>
                        </div>
                      ))}
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Faq